import { render, staticRenderFns } from "./QaListItemHeader.vue?vue&type=template&id=7203ade4&scoped=true&"
import script from "./QaListItemHeader.vue?vue&type=script&lang=js&"
export * from "./QaListItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemHeader.vue?vue&type=style&index=0&id=7203ade4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203ade4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
